import { useQuery } from "@tanstack/react-query";

const fetchData = async () => {
    const response = await fetch(process.env.REACT_APP_SOW_BLACKLIST_URL);

    return response.json();
};

export const useGetSowBlacklist = () => {

    return useQuery(["sowBlackList"], fetchData, {
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
    });
}